import React, { Fragment } from "react";
import { Layer, Image } from "react-konva";

class BackGroundLayer extends React.Component {
  state = {
    image: null
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.theme !== this.props.theme) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener("load", this.handleLoad);
  }
  loadImage() {
    // save to "this" to remove "load" handler on unmount
    this.image = new window.Image();
    this.image.src = this.props.theme;
    this.image.addEventListener("load", this.handleLoad);
  }
  handleLoad = () => {
    this.setState({
      image: this.image
    });
  };
  render() {
    return (
      <Layer>
        <Image
          image={this.state.image}
          x={0}
          y={0}
          width={window.innerWidth}
          height={window.innerHeight}
          ref={node => {
            this.imageNode = node;
          }}
        />
      </Layer>
    );
  }
}

export default BackGroundLayer;
